import { useEffect, useState } from 'react';
import type { RouteObject } from 'react-router-dom';
import {
    createBrowserRouter,
    Navigate,
    RouterProvider,
} from 'react-router-dom';

import { CONFIG } from '@/infra/config';
import { SystemType } from '@/v1/main/domain/auth';
import { MainLayout, SampleLayout } from '@/v1/main/views/Layout';
import { Login } from '@/v1/main/views/Login';
import { PageNotFound } from '@/v1/main/views/Result';
import { Setting } from '@/v1/main/views/Setting';

import { areaSettingRoutes } from './AreaSetting';
import { basicSettingRoutes } from './BasicSetting';
import { paramsConfigRoutes } from './ParamsConfig';
import { ErrorElement } from './Error';
import { eventRoutes } from './Event';
import { eventReportRoutes } from './EventReport';
import { eventSettingRoutes } from './EventSetting';
import { managementRoutes } from './Management';
import { PageElement } from './Page';
import { ProtectedRoute } from './ProtectedRoute';
import { resourceSettingRoutes } from './ResourceSetting';
import { shiftScheduleRoutes } from './ShiftSchedule';
import { userSettingRoutes } from './UserSetting';
import { DrivemapRoutes } from './DriveMap';

const webRoutes: RouteObject[] = [
    {
        element: <MainLayout />,
        errorElement: ErrorElement,
        children: [
            {
                path: `setting`,
                errorElement: ErrorElement,
                children: [
                    {
                        path: `area`,
                        errorElement: ErrorElement,
                        children: areaSettingRoutes,
                    },
                    {
                        path: `basic`,
                        errorElement: ErrorElement,
                        children: basicSettingRoutes,
                    },
                    {
                        path: `resource`,
                        errorElement: ErrorElement,
                        children: resourceSettingRoutes,
                    },
                    {
                        path: `user`,
                        errorElement: ErrorElement,
                        children: userSettingRoutes,
                    },
                    {
                        path: `event`,
                        errorElement: ErrorElement,
                        children: eventSettingRoutes,
                    },
                    {
                        path: `params_config`,
                        errorElement: ErrorElement,
                        children: paramsConfigRoutes,
                    },
                ],
            },
            {
                path: 'management',
                errorElement: ErrorElement,
                children: [
                    {
                        path: `monitor`,
                        errorElement: ErrorElement,
                        children: managementRoutes,
                    },
                    {
                        path: `event`,
                        errorElement: ErrorElement,
                        children: eventRoutes,
                    },
                    {
                        path: `shift_schedule`,
                        errorElement: ErrorElement,
                        children: shiftScheduleRoutes,
                    },
                    {
                        path: `drivemap`,
                        errorElement: ErrorElement,
                        children: DrivemapRoutes,
                    },
                ],
            },
            {
                path: 'report',
                errorElement: ErrorElement,
                children: [
                    {
                        path: `event`,
                        errorElement: ErrorElement,
                        children: eventReportRoutes,
                    },
                ],
            },
        ],
    },
    {
        element: <SampleLayout />,
        errorElement: ErrorElement,
        children: [
            {
                path: `login`,
                ...PageElement(<Login />),
            },
            { path: '*', element: <PageNotFound /> },
        ],
    },
];

const mobileRoutes: RouteObject[] = [
    {
        element: <SampleLayout />,
        errorElement: ErrorElement,
        children: [
            {
                path: `setting`,
                ...PageElement(<Setting />),
            },
            {
                path: `management`,
                errorElement: ErrorElement,
                // children: [
                //     {
                //         path: `event`,
                //         errorElement: ErrorElement,
                //         children: eventManagementRoutes,
                //     },
                // ],
            },
            {
                path: `report`,
                errorElement: ErrorElement,
                children: [
                    // {
                    //     path: `statistics`,
                    //     errorElement: ErrorElement,
                    //     children: statisticalReportRoutes,
                    // },
                ],
            },
            {
                path: `login`,
                ...PageElement(<Login />),
            },
            { path: '*', element: <PageNotFound /> },
        ],
    },
];

export const Router = () => {
    const [landing, setLanding] = useState<string>(`/${SystemType.WEB}/login`);
    const [systemRoutes, setSystemRoutes] = useState<RouteObject[]>(webRoutes);

    useEffect(() => {
        console.log('createBrowserRouter');
        let systemType = SystemType.WEB;
        let systemRoutes = webRoutes;
        if (window.location.pathname.includes(SystemType.MOB)) {
            systemType = SystemType.MOB;
            systemRoutes = mobileRoutes;
        }
        setLanding(`/${systemType}/login`);
        setSystemRoutes(systemRoutes);
    }, [window.location.pathname]);

    const routes: RouteObject[] = [
        {
            id: 'root',
            path: '/:sys',
            element: <ProtectedRoute />,
            errorElement: ErrorElement,
            children: systemRoutes,
        },
        { path: '*', element: <Navigate to={landing} replace /> },
    ];
    const router = createBrowserRouter([...routes], {
        basename: CONFIG.HTTP_BASE,
    });

    return <RouterProvider router={router} />;
};
